import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[currencyonly]',
    host: {
        '(input)': 'onInputChange()',
    },
})
export class CurrencyOnlyDirective {
    constructor(public control: NgControl) {
        this.control.valueChanges.subscribe((x) => this.handle(x));
    }

    handle(val) {
        if (!val) return;

        try {
            let newValue = val.toString().replace(/[^0-9]/g, '');
            let dispValue = newValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            this.control.valueAccessor.writeValue(dispValue);
            this.control.viewToModelUpdate(newValue);
        } catch (e) {
            console.log(e);
        }
    }

    onInputChange() {
        this.handle(this.control.value);
    }
}
